import styled from 'styled-components'
interface CardProps {
    discount?: number | null;
    customSizes?: CustomSizesType;
    widthSpacing?:string;
    rightRadius?:string;
    display?:string
}

export const DiscountContainer = styled.span<CardProps>`
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    border-color: transparent;
    border-style: ${props => props.discount ? 'solid' : 'none'} ;
    border-width: ${props => props.customSizes ? props.customSizes.width : '3em'};
    border-right-color: #ff0000;
    border-top-color: #ff0000;
    border-top-right-radius: ${props => props.customSizes?.rightRadius ? props.customSizes?.rightRadius : '10px'};
    color: white;
    text-align: center;
   
    &:after{
        content: "${props => props.discount}% off";
        position: absolute; 
        display: block;
        /* top:7; 
        right:7;  */
        /* left: 80%; */
        color:white; 
        z-index:2; 
        transform: rotate(45deg) translate(-45%,50%); 
        font-weight:700;
        font-size: ${props => props.customSizes ? props.customSizes.fontSize : '1.1em'};
        text-align: center;
        width: ${props => props.customSizes?.widthSpacing ? props.customSizes.widthSpacing : '5em'};
    }
`

export const DiscountContainerCategoryDetail = styled.span<CardProps>`
    content: '';
    position: absolute;
    top: -1%;
    right: -1%;
    border-color: transparent;
    border-style: ${props => props.discount ? 'solid' : 'none'} ;
    border-width: 3em;
    border-right-color: #ff0000;
    border-top-color: #ff0000;
    border-top-right-radius: 10px;
    color: white;
    text-align: center;
    &:after{
        content: "${props => props.discount}% off";
        position: absolute; 
        display: block;
        color:white; 
        z-index: 1; 
        transform: rotate(45deg) translate(-45%,50%); 
        font-weight:700;
        font-size: 1.1em;
        text-align: center;
        width: 5em;
    }
     @media (max-width: ${props => props.theme.breakpoints.lg}){
        right: ${props => props.display === 'tablet' ? '6%' : '13%'};
        border-width: ${props => props.display === 'tablet' ? '3em' : '1.7em'};
        &:after{
            font-size: ${props => props.display === 'tablet' ? '1.1em' : '13px'};
        }
   }
`
